import pornstar from "@/assets/menu/pornstar-martini.jpg";
import espresso from "@/assets/menu/espresso-martini.jpg";
import negroni from "@/assets/menu/negroni.jpg";
import oldFashioned from "@/assets/menu/old-fashioned.jpg";
import mojito from "@/assets/menu/mojito.jpg";
import guinness from "@/assets/menu/guinness.jpg";
import burger from "@/assets/menu/plunkets-burger.jpg";
import wings from "@/assets/menu/buffalo-wings.jpg";
import fries from "@/assets/menu/loaded-fries.jpg";
import nachos from "@/assets/menu/nachos-board.jpg";

export type MenuCategory = "Signature Cocktails" | "Classic Cocktails" | "Beers on Tap" | "From the Kitchen" | "Sharing Boards";

export type MenuItem = {
  slug: string;
  name: string;
  category: MenuCategory;
  price: string;
  tagline: string;
  description: string;
  ingredients: string[];
  pairings?: string[];
  image: string;
  badge?: string;
  sort_order?: number;
};

export const MENU: MenuItem[] = [
  {
    slug: "pornstar-martini",
    name: "Pornstar Martini",
    category: "Signature Cocktails",
    price: "€12",
    tagline: "Passion fruit, vanilla vodka, prosecco chaser.",
    description:
      "Our most-ordered cocktail. Smooth vanilla vodka shaken with fresh passion fruit and a hit of lime, served with a chilled shot of prosecco on the side. Sweet, sharp, and made for the start of a proper night out.",
    ingredients: ["Vanilla vodka", "Passoã", "Fresh passion fruit", "Lime juice", "Vanilla syrup", "Prosecco chaser"],
    pairings: ["Espresso Martini", "Loaded Fries"],
    image: pornstar,
    badge: "Most Loved",
  },
  {
    slug: "espresso-martini",
    name: "Espresso Martini",
    category: "Signature Cocktails",
    price: "€12",
    tagline: "Freshly pulled espresso, vodka, coffee liqueur.",
    description:
      "Triple-shaken with a fresh espresso pulled to order, premium vodka and coffee liqueur for a velvet crema and a proper caffeine kick. The cocktail that turns a quiet pint into a full night out.",
    ingredients: ["Premium vodka", "Coffee liqueur", "Fresh espresso", "Vanilla syrup"],
    pairings: ["Plunkets Burger", "Pornstar Martini"],
    image: espresso,
    badge: "Bartender's Pick",
  },
  {
    slug: "mojito",
    name: "Plunkets Mojito",
    category: "Signature Cocktails",
    price: "€11",
    tagline: "White rum, fresh mint, lime, soda.",
    description:
      "Hand-muddled fresh mint with lime and cane sugar, lengthened with white rum and ice-cold soda. Light, crisp and the easiest drink to keep ordering on a summer evening in Dublin.",
    ingredients: ["White rum", "Fresh mint", "Lime", "Cane sugar", "Soda water"],
    image: mojito,
  },
  {
    slug: "negroni",
    name: "Negroni",
    category: "Classic Cocktails",
    price: "€11",
    tagline: "Equal parts gin, Campari, sweet vermouth.",
    description:
      "Built over a single large ice cube and finished with a flamed orange peel. Bitter, balanced, beautiful — the way it should be.",
    ingredients: ["London dry gin", "Campari", "Sweet vermouth", "Orange peel"],
    pairings: ["Buffalo Wings"],
    image: negroni,
  },
  {
    slug: "old-fashioned",
    name: "Old Fashioned",
    category: "Classic Cocktails",
    price: "€13",
    tagline: "Bourbon, sugar, Angostura, orange oil.",
    description:
      "Bourbon stirred down with a sugar cube and a couple of dashes of Angostura bitters. Finished with an orange twist. The grown-up drink for the back-corner booth.",
    ingredients: ["Bourbon", "Sugar", "Angostura bitters", "Orange peel"],
    image: oldFashioned,
  },
  {
    slug: "guinness-pint",
    name: "Guinness",
    category: "Beers on Tap",
    price: "€6.50",
    tagline: "A proper two-part pour. No shortcuts.",
    description:
      "Poured to the harp, rested, topped. The way it's meant to be served in Dublin. We take the extra 119 seconds.",
    ingredients: ["Guinness Draught"],
    pairings: ["Plunkets Burger"],
    image: guinness,
    badge: "Two-part pour",
  },
  {
    slug: "plunkets-burger",
    name: "Plunkets Smash Burger",
    category: "From the Kitchen",
    price: "€16",
    tagline: "Double smash, aged cheddar, house sauce, fries.",
    description:
      "Two smashed Irish beef patties, aged cheddar, crunchy pickles, shredded lettuce and our house burger sauce in a toasted brioche bun. Served with golden fries and a pickle on the side.",
    ingredients: ["Irish beef (×2)", "Aged cheddar", "Brioche bun", "House burger sauce", "Pickles", "Fries"],
    pairings: ["Guinness", "Loaded Fries"],
    image: burger,
  },
  {
    slug: "buffalo-wings",
    name: "Buffalo Wings",
    category: "From the Kitchen",
    price: "€11",
    tagline: "Crispy wings, hot buffalo glaze, blue cheese dip.",
    description:
      "Eight crispy chicken wings tossed in our house buffalo glaze, served with cool blue cheese dip and celery sticks. Matchday's best friend.",
    ingredients: ["Chicken wings", "Buffalo hot sauce", "Blue cheese dip", "Celery"],
    pairings: ["Guinness"],
    image: wings,
  },
  {
    slug: "loaded-fries",
    name: "Loaded Fries",
    category: "From the Kitchen",
    price: "€9",
    tagline: "Cheddar, crispy bacon, sour cream, spring onion.",
    description:
      "Golden fries piled with melted aged cheddar, crispy bacon bits, a drizzle of sour cream and fresh spring onion. Designed to be shared — or not.",
    ingredients: ["Hand-cut fries", "Aged cheddar", "Crispy bacon", "Sour cream", "Spring onion"],
    image: fries,
  },
  {
    slug: "nachos-sharing-board",
    name: "Nachos Sharing Board",
    category: "Sharing Boards",
    price: "€14",
    tagline: "Tortilla chips, melted cheese, jalapeños, the lot.",
    description:
      "A board of warm tortilla chips loaded with melted cheese, jalapeños, salsa, guacamole and sour cream. Built for the table — perfect for matchday or pre-cocktails.",
    ingredients: ["Tortilla chips", "Cheddar & mozzarella", "Jalapeños", "Salsa", "Guacamole", "Sour cream"],
    pairings: ["Plunkets Mojito", "Guinness"],
    image: nachos,
    badge: "Made for Sharing",
  },
];

export const CATEGORIES: MenuCategory[] = [
  "Signature Cocktails",
  "Classic Cocktails",
  "Beers on Tap",
  "From the Kitchen",
  "Sharing Boards",
];

export function getMenuItem(slug: string): MenuItem | undefined {
  return MENU.find((m) => m.slug === slug);
}
